module.exports = __webpack_public_path__ + "img/feature-07.3f8b9604.png";